<template>
	<div class="advert-manage-container">
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.planNo" placeholder="请输入销账批次号" />
				</el-col>
				<el-col :span="6">
					<el-date-picker
						v-model="query.tradeDateRange"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						style="width: 100%" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.customerName" placeholder="请输入流水客户名称" />
				</el-col>
			</template>

			<template slot="more">
				<el-col :span="6">
					<el-input v-model="query.customerAccount" placeholder="请输入流水客户账号" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.amount" placeholder="请输入发生金额" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.feeType" placeholder="请输入费用类型" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.clientName" placeholder="请输入客户名称" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.resourceName" placeholder="请输入资源名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.status" placeholder="请选择状态" style="width: 100%">
						<el-option label="待析账" value="待析账" />
						<el-option label="析账失败" value="析账失败" />
						<el-option label="待销账" value="待销账" />
						<el-option label="已销账" value="已销账" />
						<el-option label="销账失败" value="销账失败" />
					</el-select>
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.transactionNo" placeholder="请输入交易流水号" />
				</el-col>
			</template>
		</QueryCard>

		<!-- 表格 -->
		<BaseTable
			:actions="{
				operation: true,
			}"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.pageNum"
			:pageSize="query.pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template slot="status" slot-scope="{ row }">
				<el-tag :type="getStatusType(row.status)" size="mini">
					{{ row.status }}
				</el-tag>
			</template>
			<template #operation="{ row }">
				<el-button type="text" @click="handleViewArrears(row)">欠费明细</el-button>
				<el-button type="text" @click="handleWriteOff(row)" v-if="row.status === '待销账' || row.status === '销账失败'">
					销账
				</el-button>
			</template>
		</BaseTable>
		<WriteOffDetailsDialog :dialogVisible.sync="dialogVisible" />
		<WriteOffDetailsOffDialog :dialogVisible.sync="dialogOffVisible" />
	</div>
</template>

<script>
	import { getCommunityId } from '@/utils/vc.js';
	import WriteOffDetailsDialog from '@/components/assets/writeOffDetailsDialog.vue';
	import WriteOffDetailsOffDialog from '@/components/assets/writeOffDetailsOffDialog.vue';
	export default {
		name: 'WriteOffDetails',
		components: {
			WriteOffDetailsDialog,
			WriteOffDetailsOffDialog,
		},
		data() {
			return {
				dialogVisible: false,
				dialogOffVisible: false,
				loading: false,
				total: 0,
				query: {
					planNo: '',
					tradeDateRange: [], // 👈 关键：时间范围
					customerName: '',
					customerAccount: '',
					amount: '',
					feeType: '',
					clientName: '',
					resourceName: '',
					status: '',
					transactionNo: '',
					communityId: getCommunityId(),
					pageNum: 1,
					pageSize: 10,
				},
				tableData: [
					{
						planNo: 'DG20231007000001',
						tradeDate: '2023-10-19 10:30:00',
						customerName: '张三',
						customerAccount: '65558585271',
						amount: 264.4,
						feeType: '物业费',
						matchCustomer: '张三',
						matchResource: '01-0101',
						writeOffAmount: 264.4,
						status: '待析账',
						transactionNo: 'ICBC213830',
					},
					{
						planNo: 'DG20231007000002',
						tradeDate: '2023-10-18 14:25:00',
						customerName: '李四',
						customerAccount: '65558585270',
						amount: 299.18,
						feeType: '车位费',
						matchCustomer: '李四',
						matchResource: '01-0102',
						writeOffAmount: 299.18,
						status: '析账失败',
						transactionNo: 'ICBC213828',
					},
					{
						planNo: 'DG20231007000003',
						tradeDate: '2023-10-17 09:15:00',
						customerName: '王五',
						customerAccount: '65558585275',
						amount: 260.18,
						feeType: '物业费',
						matchCustomer: '王五',
						matchResource: '01-0103',
						writeOffAmount: 260.18,
						status: '待销账',
						transactionNo: 'ICBC213838',
					},
					{
						planNo: 'DG20231007000004',
						tradeDate: '2023-10-17 16:45:00',
						customerName: '赵六',
						customerAccount: '65558585269',
						amount: 297.83,
						feeType: '水电费',
						matchCustomer: '赵六',
						matchResource: '01-0104',
						writeOffAmount: 297.83,
						status: '已销账',
						transactionNo: 'ICBC213826',
					},
					{
						planNo: 'DG20231007000005',
						tradeDate: '2023-10-16 11:20:00',
						customerName: '孙七',
						customerAccount: '65558585268',
						amount: 218.38,
						feeType: '物业费',
						matchCustomer: '孙七',
						matchResource: '01-0105',
						writeOffAmount: 218.38,
						status: '销账失败',
						transactionNo: 'ICBC213824',
					},
				],
				columns: [
					{ prop: 'planNo', label: '销账批次号' },
					{ prop: 'tradeDate', label: '交易日期', width: '180px' },
					{ prop: 'customerName', label: '流水客户名称', width: '120px' },
					{ prop: 'customerAccount', label: '流水客户账号', width: '160px' },
					{ prop: 'amount', label: '发生金额', width: '120px' },
					{ prop: 'feeType', label: '费用类型', width: '120px' },
					{ prop: 'matchCustomer', label: '匹配客户', width: '120px' },
					{ prop: 'matchResource', label: '匹配资源', width: '120px' },
					{ prop: 'writeOffAmount', label: '销账金额', width: '120px' },
					{ prop: 'status', label: '状态', width: '120px', slot: 'status' },
					{ prop: 'transactionNo', label: '交易流水号', width: '160px' },
				],
				currentRow: {},
			};
		},
		created() {},
		methods: {
			getStatusType(status) {
				const map = {
					待析账: 'info',
					析账失败: 'danger',
					待销账: 'warning',
					已销账: 'success',
					销账失败: 'danger',
				};
				return map[status] || '';
			},
			handleSearch() {},
			handleReset() {
				this.query = {
					planNo: '',
					tradeDateRange: [],
					customerName: '',
					customerAccount: '',
					amount: '',
					feeType: '',
					clientName: '',
					resourceName: '',
					status: '',
					transactionNo: '',
					communityId: getCommunityId(),
					pageNum: 1,
					pageSize: 10,
				};
			},
			pageChange(page) {
				this.query.pageNum = page;
			},
			sizeChange(size) {
				this.query.pageSize = size;
			},
			handleViewArrears(row) {
				this.currentRow = row;
				this.dialogVisible = true;
			},
			handleWriteOff(row) {
				this.currentRow = row;
				this.dialogOffVisible = true;
			},
		},
	};
</script>

<style scoped lang="scss">
	.advert-manage-container {
		padding: 20px;
		color: #1c1c1c;
		text-align: left;
	}
</style>
